import { CustomerResponse } from "src/api/types/responses";
import { CaseFormTypes } from "src/pages/case-landing/case-form-setup";
import { BankValidationStatus } from "src/api/types/enums";
import { UpdateRequest } from "src/api/types/requests";
import { apiPostcodeRegex } from "src/utils/regex";

const deepClean = <T>(obj: T): T | undefined => {
  if (obj !== null && typeof obj === "object") {
    const cleanedEntries = Object.entries(obj)
      .map(([k, v]) => [k, deepClean(v)])
      .filter(([_, v]) => v !== undefined);

    return cleanedEntries.length === 0 ? undefined : (Object.fromEntries(cleanedEntries) as T);
  }
  return obj;
};

export const mapCustomerUpdateFormData = (formData: CaseFormTypes): UpdateRequest => {
  let redressParticipation;

  if (formData.optStatus === "opt-in") {
    redressParticipation = "optedIn";
  } else if (formData.optStatus === "opt-out") {
    redressParticipation = "optedOut";
  }

  const data = {
    fullName: formData.fullName,
    email: formData.email,
    homePhone: formData.homePhone,
    offerStatus: formData.offerStatus,
    address: {
      streetName:
        [formData.address?.addressLine1, formData.address?.addressLine2].filter(Boolean).join(" ") || undefined,
      city: formData.address?.city,
      county: formData.address?.county,
      postCode: sanitisePostcode(formData.address?.postCode),
      country: formData.address?.country,
    },
    preferredContactChannel: formData.preferredContactChannel,
    bank: {
      accountHoldername: formData.bankDetails?.payeeName,
      sortCode: formData.bankDetails?.sortCode?.replaceAll("-", ""),
      accountNumber: formData.bankDetails?.accountNumber,
    },
    reasonForChallenge: formData.challengeReason,
    challengeExplanation: formData.challengeExplanation,
    redress: {
      redressParticipation: redressParticipation,
      docsUploadStatus: formData.redress?.docsUploadStatus,
    },
  };

  return deepClean(data) as UpdateRequest;
};

const sanitisePostcode = (postCode: string | undefined) => {
  if (!postCode) {
    return postCode;
  }

  const matcher = new RegExp(apiPostcodeRegex);
  if (matcher.test(postCode)) {
    return postCode;
  }

  return `${postCode.slice(0, -3)} ${postCode.slice(-3)}`;
};
